<template>
  <router-link :to="resolveFn(col.to, item, index)">
    {{ value }}
  </router-link>
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';

export default {
  mixins: [ BaseColumnRendererMixin ]
};
</script>
